import { MapperConnectionReference } from 'app/model/adfDataMapper/mapperConnectionReference';
import { IColumn } from 'shell-models-lib';
import { IMapperTable } from 'app/model/adfDataMapper/IMapperTable';

export class MapperTableReference {
    public readonly table: IMapperTable;
    public entityConnectionReference: MapperConnectionReference;
    public readonly columns: IColumn[] = [];

    constructor(table: IMapperTable, entityConnectionReference: MapperConnectionReference, columns?: IColumn[]) {
        this.table = table;
        this.entityConnectionReference = entityConnectionReference;

        if (columns) {
            this.columns = columns;
        }
    }

    public getUniqueAlias(): string {
        return this.entityConnectionReference.getConnectionAlias() + '@' + this.table?.tableName;
    }

    public isValidReference(): boolean {
        return !!this.table?.tableName
            && !!this.entityConnectionReference
            && !!this.entityConnectionReference.connectionName
            && !!this.entityConnectionReference.type;
    }
}
